import React from "react";
import logo from "../../assets/logo.png";
import BGFooter from "../../assets/bgfooter.png";
import { FaFacebook } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";

const Footer = () => {
  return (
    <footer
      className="bg-primary text-primary py-10 px-5 md:px-10"
      style={{
        backgroundImage: `url(${BGFooter})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="max-w-8xl mx-auto">
        {/* Main footer content - grid layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mb-10 gap-10">
          {/* Brand Section */}
          <div className="text-center md:text-left">
            <div className="flex flex-row items-center justify-center md:justify-start">
              <img src={logo} alt="GDesk" className="h-20 w-auto" />
              <h2 className="text-5xl font-semibold">GDesk</h2>
            </div>
            <div className="mt-4">
              <p className="text-black text-lg leading-relaxed">
                Helping businesses grow <br />
                smarter and faster.
              </p>
            </div>
          </div>

          <div className="text-center md:text-left">
            <div className="md:flex md:flex-col md:items-start">
              <h3 className="text-lg font-semibold mb-4 border-b border-primary inline-block pb-1">
                Services
              </h3>
              <ul className="space-y-2 text-sm text-black">
                <li>Medical Virtual Assistance</li>
                <li>Social Media Management</li>
                <li>Internal Campaign Management</li>
                <li>Customer Service Support</li>
                <li>General Virtual Assistance</li>
                <li>Web Design & Website Support</li>
              </ul>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="text-center md:text-left">
            <div className="md:flex md:flex-col md:items-start">
              <h3 className="text-lg font-semibold mb-4 border-b border-primary inline-block pb-1">
                Quick Links
              </h3>
              <ul className="space-y-2 text-sm text-black">
                <li>
                  <a href="#home" className="hover:text-primary">
                    Home
                  </a>
                </li>
                <li>
                  <a href="#service" className="hover:text-primary">
                    Services
                  </a>
                </li>
                <li>
                  <a href="#about" className="hover:text-primary">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#faq" className="hover:text-primary">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Contacts Section */}

          <div className="text-center md:text-left">
            <div className="md:flex md:flex-col md:items-start">
              <h3
              id="contact"
               className="text-lg font-semibold mb-4 border-b border-primary inline-block pb-1">
                Contacts
              </h3>
              <div className="space-y-3 text-sm text-black">
                {/* Email */}
                <div className="flex items-center gap-2 justify-center md:justify-start">
                <MdEmail/>
                  <a
                    href="mailto:Gdeskvirtualassistance@gmail.com"
                    className="hover:text-primary"
                  >
                    Gdeskvirtualassistance@gmail.com
                  </a>
                </div>

                {/* Facebook Link */}
                <div className="flex items-center gap-2 justify-center md:justify-start">
                <FaFacebook />
                  <a
                    href="https://www.facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-primary"
                  >
                    GDesk
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar with copyright */}
        <div className="border-t border-primary pt-6 mt-4 text-center text-black text-xs">
          <p>&copy; {new Date().getFullYear()} GDesk. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
